<template>
  <div class="cab-sidebar">
    <div class="cab-navbar sticky-top">
      <div style="align-items:center;display:flex;height:60px;margin-left:10px">

        <h3> </h3>
      </div>
    </div>
    <div class="sidebar-content pt-3">
      <div class="ml-0 pt-2">
        <div class="sidebar-content-header ml-3 pb-4">DRAWERS</div>
        <ul class="list-group list-group-cab">
          <li
            class="list-group-item list-group-item-cab drawers"
            v-for="drawer in drawers"
            :key="drawer.id"
          >
            <font-awesome-icon
              icon="inbox"
              class="mr-3"
            />{{ drawer.title }}</li>
        </ul>
      </div>
      <div class="ml-0 pt-5">
        <div class="sidebar-content-header ml-3 pb-4">ALL HASHTAGS</div>
        <ul class="list-group list-group-cab">
          <li
            class="list-group-item pt-2 pb-2 hashtags"
            v-for="hashtag in hashtags"
            :key="hashtag.id"
          >
            <font-awesome-icon
              icon="hashtag"
              class="mr-3"
              style="font-size: 0.8em;color:gray"
            />{{ hashtag.title }}</li>
        </ul>
      </div>
      <div style="height:50px"></div>
    </div>
  </div>
</template>

<script>
import SpacerList from "@/components/SpacerList";

export default {
  name: "Sidebar",
  components: {
    SpacerList
  },
  computed: {
    drawers() {
      return this.$store.getters.getDrawers;
    },
    hashtags() {
      return this.$store.getters.getHashtags;
    }
  }
};
</script>

<style scoped>
.cab-sidebar {
  background: #50557d;
  color: #fff;
  min-height: 100vh;
}
.cab-navbar {
  height: 60px;
  border-bottom: 1px solid #575c87;
  background: #50557d;
}

.sidebar-content {
  /* padding-top: 30px; */
  color: white;
}

.sidebar-content-header {
  /* margin-left: 10px; */
  font-size: 12px;
  color: lightgray;
}

.list-group-cab .list-group-item {
  background-color: #50557d;
  border-top: 0px;
  border-bottom: 0px;
  color: white;
  cursor: pointer;
}

.list-group-cab .list-group-item:hover {
  background-color: #434768;
}

.drawers {
  font-size: 1.3em;
}

.hashtags {
  font-size: 1em;
}
</style>
